import { API_URL } from "@/constants/envVariables";
import { getSdpTenantName } from "@/helpers/getSdpTenantName";

export const completeOnboarding = async (token: string): Promise<void> => {
  const response = await fetch(`${API_URL}/onboarding/complete`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "SDP-Tenant-Name": getSdpTenantName(),
    },
  });

  if (!response.ok) {
    const error = await response.json();
    throw error;
  }
};
